// eslint-disable-next-line import/no-default-export
export { default, default as NumberField, StyledNumberField, } from './NumberField';
if (window?.location.hostname.includes('localhost') ||
    window?.location.hostname.includes('staging')) {
    console.warn('NumberField is deprecated and will be removed in the future. Please use NumberInput from @clds/input instead.');
}
//# sourceMappingURL=index.js.map